import type { BankWaypoint, GroupWaypoint, Waypoint } from "./types";

export const DEFAULT_DRAWER_WIDTH = 420;
export const DEFAULT_BANK_DRAWER_WIDTH = 460;

export const DEFAULT_BACKGROUND_OPACITY = 80;
export const DEFAULT_WAYPOINT_BACKGROUND_SIZE = 50;
export const DEFAULT_GROUP_BACKGROUND_WIDTH = 200;
export const DEFAULT_GROUP_BACKGROUND_HEIGHT = 500;
export const DEFAULT_BANK_BACKGROUND_WIDTH = 260;
export const DEFAULT_BANK_BACKGROUND_HEIGHT = 120;

export const DEFAULT_WAYPOINT_BACKGROUND_COLOR = "#000000";
export const DEFAULT_GROUP_BACKGROUND_COLOR = "#add8e6";
export const DEFAULT_BANK_BACKGROUND_COLOR = "#6ab7ff";
export const DEFAULT_FONT_COLOR = "#000000";

export const DEFAULT_FONT_SIZE = 14;
export const DEFAULT_ICON_SIZE = 24;
export const DEFAULT_ROTATION = 0;

export const MIN_SHAPE_SIZE = 8;
export const MIN_ICON_SIZE = 4;

export const DEFAULT_SYNC_ROTATIONS = true;
export const DEFAULT_MAINTAIN_ICON_ASPECT_RATIO = true;
export const DEFAULT_LINK_LIFTS = true;

export const LINKED_LIFTS_TOOLTIP =
  "When lifts are linked together all rotations, resizing, and moving of either the bank or any other linked lift will apply propotionately to all other lifts and the parent bank.";

export const LIFT_GROUP_OPTIONS = [
  { value: "Group East", label: "Group East" },
  { value: "Group West", label: "Group West" },
  { value: "Group Central", label: "Group Central" },
];

export const LINKED_BANK_OPTIONS = [
  { value: "Bank A", label: "Bank A" },
  { value: "Bank B", label: "Bank B" },
  { value: "Bank C", label: "Bank C" },
];

export const LINKED_LIFT_OPTIONS = [
  { value: "Lift 1", label: "Lift 1" },
  { value: "Lift 2", label: "Lift 2" },
  { value: "Lift 3", label: "Lift 3" },
];

export const DEFAULT_WAYPOINT_VIEW: Pick<
  Waypoint,
  | "backgroundColorHex"
  | "backgroundOpacity"
  | "backgroundWidth"
  | "backgroundHeight"
  | "backgroundRotationDeg"
  | "iconRotationDeg"
  | "nameRotationDeg"
  | "syncRotations"
  | "iconWidth"
  | "iconHeight"
  | "maintainIconAspectRatio"
> = {
  backgroundColorHex: DEFAULT_WAYPOINT_BACKGROUND_COLOR,
  backgroundOpacity: DEFAULT_BACKGROUND_OPACITY,
  backgroundWidth: DEFAULT_WAYPOINT_BACKGROUND_SIZE,
  backgroundHeight: DEFAULT_WAYPOINT_BACKGROUND_SIZE,
  backgroundRotationDeg: DEFAULT_ROTATION,
  iconRotationDeg: DEFAULT_ROTATION,
  nameRotationDeg: DEFAULT_ROTATION,
  syncRotations: DEFAULT_SYNC_ROTATIONS,
  iconWidth: DEFAULT_ICON_SIZE,
  iconHeight: DEFAULT_ICON_SIZE,
  maintainIconAspectRatio: DEFAULT_MAINTAIN_ICON_ASPECT_RATIO,
};

export const DEFAULT_BANK_LIFT_VISUAL: Pick<
  Waypoint,
  | "backgroundColorHex"
  | "backgroundOpacity"
  | "backgroundWidth"
  | "backgroundHeight"
  | "displayName"
  | "fontSize"
  | "fontColorHex"
  | "backgroundRotationDeg"
  | "iconRotationDeg"
  | "nameRotationDeg"
  | "syncRotations"
  | "iconWidth"
  | "iconHeight"
  | "maintainIconAspectRatio"
> = {
  ...DEFAULT_WAYPOINT_VIEW,
  displayName: true,
  fontSize: DEFAULT_FONT_SIZE,
  fontColorHex: DEFAULT_FONT_COLOR,
};

export const DEFAULT_GROUP_WAYPOINT_VIEW: Pick<
  GroupWaypoint,
  | "backgroundColorHex"
  | "backgroundOpacity"
  | "backgroundWidth"
  | "backgroundHeight"
  | "backgroundRotationDeg"
  | "nameRotationDeg"
  | "syncRotations"
> = {
  backgroundColorHex: DEFAULT_GROUP_BACKGROUND_COLOR,
  backgroundOpacity: DEFAULT_BACKGROUND_OPACITY,
  backgroundWidth: DEFAULT_GROUP_BACKGROUND_WIDTH,
  backgroundHeight: DEFAULT_GROUP_BACKGROUND_HEIGHT,
  backgroundRotationDeg: DEFAULT_ROTATION,
  nameRotationDeg: DEFAULT_ROTATION,
  syncRotations: DEFAULT_SYNC_ROTATIONS,
};

export const DEFAULT_BANK_WAYPOINT_VIEW: Pick<
  BankWaypoint,
  | "backgroundColorHex"
  | "backgroundOpacity"
  | "backgroundWidth"
  | "backgroundHeight"
  | "backgroundRotationDeg"
  | "nameRotationDeg"
  | "syncRotations"
  | "linkLifts"
> = {
  backgroundColorHex: DEFAULT_BANK_BACKGROUND_COLOR,
  backgroundOpacity: 55,
  backgroundWidth: DEFAULT_BANK_BACKGROUND_WIDTH,
  backgroundHeight: DEFAULT_BANK_BACKGROUND_HEIGHT,
  backgroundRotationDeg: DEFAULT_ROTATION,
  nameRotationDeg: DEFAULT_ROTATION,
  syncRotations: DEFAULT_SYNC_ROTATIONS,
  linkLifts: DEFAULT_LINK_LIFTS,
};

export const BANK_LIFT_PIN_SPACING = 90;
export const NO_MAP_FOUND_DESCRIPTION = "No map found for the selected id";

export function getDefaultBankWidthForLiftCount(liftCount: number): number {
  if (liftCount < 3) {
    return DEFAULT_BANK_BACKGROUND_WIDTH;
  }

  return DEFAULT_WAYPOINT_BACKGROUND_SIZE * liftCount + BANK_LIFT_PIN_SPACING * (liftCount - 1);
}
